/**
 * 15 màn hình AGADS — bản dùng cho frontend.
 *
 * `d` là đường SVG lấy nguyên từ mảng `NAV` trong `AGADS.dc.html` để giữ đúng
 * bộ biểu tượng của thiết kế gốc.
 *
 * Việc ẩn/hiện menu ở đây CHỈ là lớp trình bày. Backend vẫn tự kiểm tra quyền
 * ở từng endpoint (`canManHinh`), nên sửa dữ liệu này trong trình duyệt không
 * mở thêm được gì.
 */

import { NEN_TANG_QC } from './nen-tang-qc';

export interface ManHinh {
  id: string;
  label: string;
  /** Đường dẫn route. */
  duong: string;
  /** Đường SVG của biểu tượng. */
  d: string;
  trongMenu: boolean;
}

export const MAN_HINH: readonly ManHinh[] = [
  {
    id: 'dashboard',
    label: 'Dashboard tổng quan',
    duong: '/',
    d: 'M4 4h6v6H4zM14 4h6v4h-6zM14 12h6v8h-6zM4 14h6v6H4z',
    trongMenu: true,
  },
  {
    id: 'launcher',
    label: 'Ra lệnh',
    duong: '/ra-lenh',
    d: 'M5 12h11M12 7l5 5-5 5',
    trongMenu: true,
  },
  {
    id: 'advisor',
    label: 'AGADS AI tư vấn',
    duong: '/ai-tu-van',
    d: 'M12 4l1.7 4.3L18 10l-4.3 1.7L12 16l-1.7-4.3L6 10l4.3-1.7zM18 15l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z',
    trongMenu: true,
  },
  {
    id: 'crm',
    // BOSS 19/10/2026: đổi tên.
    label: 'CRM & CSKH',
    duong: '/crm',
    d: 'M12 4a4 4 0 110 8 4 4 0 010-8M5 20a7 7 0 0114 0',
    trongMenu: true,
  },
  {
    id: 'data',
    label: 'Data Board',
    duong: '/data-board',
    d: 'M5 19V11M12 19V5M19 19v-6',
    trongMenu: true,
  },
  {
    id: 'accounts',
    // BOSS 14/10/2026: đổi tên + 14 mục con nền tảng ở đầu trang.
    label: 'Quảng cáo đa nền tảng',
    duong: '/tai-khoan-quang-cao',
    d: 'M4 5h16v5H4zM4 14h16v5H4M7 7.5h.01M7 16.5h.01',
    trongMenu: true,
  },
  {
    id: 'zalo',
    label: 'Zalo OA',
    duong: '/zalo-oa',
    d: 'M4 5h16v11H9l-4 3v-3H4zM8 9h8M8 12h5',
    trongMenu: true,
  },
  {
    // BOSS 16/10/2026: AI trả lời khách trên hộp chat Pancake + tự lên đơn.
    id: 'chatbot',
    label: 'AI trả lời khách',
    duong: '/ai-tra-loi-khach',
    d: 'M4 5h12v9H8l-4 3v-3H4zM18 9h2v8h-1v3l-3-3h-6M8 9h4',
    trongMenu: true,
  },
  {
    // BOSS 19/10/2026: CRM & CSKH › Tệp khách hàng — khách theo nguồn + nhập danh sách.
    id: 'tep_khach',
    label: 'Tệp khách hàng',
    duong: '/tep-khach-hang',
    d: 'M9 4a3 3 0 110 6 3 3 0 010-6M3 18a6 6 0 0112 0M16 6a3 3 0 010 6M17 14a5 5 0 014 4',
    trongMenu: true,
  },
  {
    // BOSS 07/10/2026: số liệu từng kênh YouTube (chỉ đọc).
    id: 'youtube',
    label: 'YouTube',
    duong: '/youtube',
    d: 'M3 8.5c0-1.4 1-2.6 2.4-2.8C7.6 5.4 9.8 5.3 12 5.3s4.4.1 6.6.4c1.4.2 2.4 1.4 2.4 2.8v7c0 1.4-1 2.6-2.4 2.8-2.2.3-4.4.4-6.6.4s-4.4-.1-6.6-.4C4 18.1 3 16.9 3 15.5zM10 9.5v5l4.5-2.5z',
    trongMenu: true,
  },
  {
    id: 'misa',
    label: 'Đối soát MISA',
    duong: '/doi-soat-misa',
    d: 'M6 3h12v18H6zM9 8h6M9 12h6M9 16h3',
    trongMenu: true,
  },
  {
    id: 'guardrail',
    label: 'Guardrail ngân sách',
    duong: '/guardrail',
    d: 'M12 4l7 3v5c0 4-3 7-7 8-4-1-7-4-7-8V7z',
    trongMenu: true,
  },
  {
    id: 'queue',
    label: 'Hàng chờ duyệt',
    duong: '/hang-cho-duyet',
    d: 'M20 6L9 17l-5-5',
    trongMenu: true,
  },
  {
    id: 'log',
    label: 'Nhật ký & Báo cáo',
    duong: '/nhat-ky',
    d: 'M12 7v5l3 2M12 4a8 8 0 100 16 8 8 0 000-16',
    trongMenu: true,
  },
  {
    id: 'connect',
    label: 'Kết nối nền tảng',
    duong: '/ket-noi',
    d: 'M9 15l6-6M8 17a3.5 3.5 0 01-1-5l2-2M16 7a3.5 3.5 0 011 5l-2 2',
    trongMenu: true,
  },
  {
    id: 'settings',
    label: 'Cài đặt',
    duong: '/cai-dat',
    d: 'M12 9.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5M12 3v2.5M12 18.5V21M4.5 12H3M21 12h-1.5M6.2 6.2l1.8 1.8M16 16l1.8 1.8M17.8 6.2L16 8M8 16l-1.8 1.8',
    trongMenu: true,
  },
  // --- 3 màn ngoài menu, mở từ trang khác ---
  {
    id: 'invsync',
    label: 'Hoá đơn gốc bên MISA',
    duong: '/dong-bo-hoa-don',
    d: 'M4 12a8 8 0 0113.7-5.7M20 12a8 8 0 01-13.7 5.7M17 4v3h-3M7 20v-3h3',
    trongMenu: false,
  },
  {
    // Extension AGADS — Đợt 1 chỉ đọc (BOSS duyệt 09/10/2026). Hiện khi có quyền "Dùng extension"
    // hoặc là Administrator / Chủ DN (màn "Tất cả máy" — C8); xem coManHinh ở KhungChinh.
    id: 'extension',
    label: 'Extension AGADS',
    duong: '/extension',
    d: 'M4 6h10v4h2a2 2 0 110 4h-2v4H4v-4h2a2 2 0 100-4H4z',
    trongMenu: true,
  },
  {
    // Robot MISA (BOSS duyệt 01/10/2026) — mở từ màn Đối soát MISA, cùng quyền xem với màn đó.
    id: 'robot-misa',
    label: 'Robot MISA',
    duong: '/robot-misa',
    d: 'M8 8h8v8H8zM12 4v4M6 12H4M20 12h-2M10 12h.01M14 12h.01M10 18v2M14 18v2',
    trongMenu: false,
  },
  {
    id: 'profile',
    label: 'Hồ sơ tài khoản',
    duong: '/ho-so',
    d: 'M12 4a4 4 0 110 8 4 4 0 010-8M5 20a7 7 0 0114 0',
    trongMenu: false,
  },
  {
    id: 'perms',
    label: 'Cấp quyền',
    duong: '/cap-quyen',
    d: 'M12 4l7 3v5c0 4-3 7-7 8-4-1-7-4-7-8V7zM9.5 12l1.8 1.8L15 10',
    trongMenu: false,
  },
];

/**
 * Ba tab cố định ở thanh dưới khi xem trên điện thoại (< 760px).
 *
 * Tab thứ tư là nút "Thêm" — mở ngăn kéo chứa mọi màn còn lại, đúng như thiết
 * kế gốc. Không có nút đó thì trên điện thoại chỉ vào được 3 trong 15 màn.
 */
export const TAB_DIEN_THOAI: readonly { id: string; label: string }[] = [
  { id: 'dashboard', label: 'Tổng quan' },
  { id: 'launcher', label: 'Ra lệnh' },
  { id: 'queue', label: 'Chờ duyệt' },
];

/**
 * MENU TRÁI — 9 mục chính CỐ ĐỊNH, đúng thứ tự BOSS chốt 19/10/2026 ("không thêm không bớt"). Bấm mục
 * chính mở màn của nó và sổ menu con. Thêm màn mới thì đưa vào làm mục CON của một trong 9 mục này,
 * không thêm mục chính.
 */
export interface MucConMenu {
  nhan: string;
  /** Đường dẫn, có thể kèm ?query (vd mục con nền tảng quảng cáo ?nen=meta-ig). */
  duong: string;
  /** Màn quyết định quyền xem mục con này. */
  manHinh: string;
}
export interface NhomMenu {
  /** Màn của mục chính. */
  id: string;
  con: readonly MucConMenu[];
}

const DUONG_QC = '/tai-khoan-quang-cao';

export const NHOM_MENU: readonly NhomMenu[] = [
  // 1. Mọi dashboard nằm trong "Dashboard tổng quan".
  { id: 'dashboard', con: [{ nhan: 'Data Board', duong: '/data-board', manHinh: 'data' }] },
  // 2. "Hàng chờ duyệt" đứng đầu, rồi "Ra lệnh", cuối là "Guardrail ngân sách".
  {
    id: 'advisor',
    con: [
      { nhan: 'Hàng chờ duyệt', duong: '/hang-cho-duyet', manHinh: 'queue' },
      { nhan: 'Ra lệnh', duong: '/ra-lenh', manHinh: 'launcher' },
      { nhan: 'Guardrail ngân sách', duong: '/guardrail', manHinh: 'guardrail' },
    ],
  },
  // 3. Các nền tảng sẵn có trong màn + Zalo OA + YouTube.
  {
    id: 'accounts',
    con: [
      ...NEN_TANG_QC.map((n) => ({
        nhan: n.ten,
        duong: n.ma === 'meta-fb' ? DUONG_QC : `${DUONG_QC}?nen=${n.ma}`,
        manHinh: 'accounts',
      })),
      { nhan: 'Zalo OA', duong: '/zalo-oa', manHinh: 'zalo' },
      { nhan: 'YouTube', duong: '/youtube', manHinh: 'youtube' },
    ],
  },
  // 4. "CRM & CSKH": AI trả lời khách (+ Tệp khách hàng — đợt 2).
  {
    id: 'crm',
    con: [
      { nhan: 'AI trả lời khách', duong: '/ai-tra-loi-khach', manHinh: 'chatbot' },
      { nhan: 'Tệp khách hàng', duong: '/tep-khach-hang', manHinh: 'tep_khach' },
    ],
  },
  { id: 'misa', con: [] },
  { id: 'extension', con: [] },
  { id: 'connect', con: [] },
  { id: 'settings', con: [] },
  { id: 'log', con: [] },
];

/** Đường dẫn (pathname + query) có phải đúng mục này không. Mục không có query khớp khi không có ?nen=. */
export function laDuongDangMo(duong: string, pathname: string, search: string): boolean {
  const [p, q] = duong.split('?');
  if (p !== pathname) return false;
  const nen = new URLSearchParams(search).get('nen');
  const nenMuc = q ? new URLSearchParams(q).get('nen') : null;
  return p === DUONG_QC ? (nen || null) === nenMuc : true;
}

export function timManHinh(id: string): ManHinh | undefined {
  return MAN_HINH.find((m) => m.id === id);
}

/**
 * Có được vào màn này không (lớp TRÌNH BÀY — backend vẫn tự kiểm). Màn "extension" không có công tắc
 * nav riêng: mở khi có quyền act.dung_extension (C7) hoặc là Administrator / Chủ DN (C8).
 */
export function coManHinh(id: string, co: (nhom: 'nav' | 'act' | 'data' | 'ai' | 'adm', khoa: string) => boolean, roleId?: string): boolean {
  if (id === 'extension') return co('act', 'dung_extension') || roleId === 'administrator' || roleId === 'boss';
  return co('nav', id);
}
